import { render, staticRenderFns } from "./PlatformAccount.vue?vue&type=template&id=3da32530&scoped=true&"
import script from "./PlatformAccount.vue?vue&type=script&lang=js&"
export * from "./PlatformAccount.vue?vue&type=script&lang=js&"
import style0 from "./PlatformAccount.vue?vue&type=style&index=0&id=3da32530&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da32530",
  null
  
)

export default component.exports